import { FunctionComponent } from 'react';
import { FilterModalTextInput } from '../../../../sharedComponents/filter/FilterModal';
import { CompoundFilterProps } from './CompoundFilterProps';
import { useOnChangeTextFilter } from '../../../../sharedComponents/filter/useOnChangeTextFilter';

export const MeansOfTransportIdFilter: FunctionComponent<CompoundFilterProps> = ({ localFilters, setLocalFilters }) => {
    const handleChange = useOnChangeTextFilter('meansOfTransportIdFilter', setLocalFilters);

    return (
        <FilterModalTextInput
            id="means-of-transport-id-filter"
            headerMessageId="outboundOrderBook.common.filter.meansOfTransportId"
            inputAddon="rioglyph rioglyph-truck"
            placeholderMessageId="outboundOrderBook.common.filter.enterMeansOfTransportId"
            isOptional
            value={localFilters.meansOfTransportIdFilter}
            onChange={handleChange}
        />
    );
};
